import { Component } from '@angular/core';
import { CtrBaseComponent } from '../ctr-base.component';

@Component({
    ...CtrBaseComponent.metaData,
    selector: 'app-ctr-pension-income',
    templateUrl: './ctr-pension-income.component.html',
    styleUrls: ['../ctr-base.component.scss'],
    standalone: false
})
export class CtrPensionIncomeComponent extends CtrBaseComponent {
}
